import React, { useState, useEffect } from 'react';

import SelectUi from './uiComponents/Select/Select'

const DropDown = (props) => {
  const { value, readonly, onChange, schema, t } = props
  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const onInputChanged = (e) => {
    const newValue = e.target.id
    setSelectedValue(newValue)
    onChange(newValue)
  }

  const getData = () => schema.enum
    ? schema.enum.map((value, index) => {
      return {
        ID: value,
        Name: schema.enumNames[index],
      }
    })
    : []

  return (
    <div className={`drop-down-duc form-control ${readonly ? 'disabled' : ''}`} >
      <SelectUi
        readonly={getData().length <= 0 ? true : readonly}
        value={selectedValue}
        optionsEnums={[{ID: '', Name: `-- ${t('ducs.please_select_value')} --`}].concat(getData())}
        onInputChanged={onInputChanged}
      />
    </div>
  )
}

if (typeof window !== 'undefined') {
  window.uStoreDucs = window.uStoreDucs || []
  window.uStoreDucs.push({ name: 'dropDownList', component: DropDown, displayNames: ['Dropdown List', 'Dependent Dropdown List'] })
}

export default DropDown
